import script from "./base-table.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-table.vue?vue&type=script&setup=true&lang=ts"

import "./base-table.vue?vue&type=style&index=0&id=dccb614c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dccb614c"]])

export default __exports__